import { useEffect, useState } from "react";
import { FacilitatorModel } from "../../../hooks/community/models/FacilitatorModel";
import { useFacilitators } from "../../../hooks/community/useFacilitators";


type Props = {
    value: number | null;
    onChange: (value: number) => void;
    onAddNewTeamMember: () => void;
}

export const CommunityFacilitatorSelect = ({ value, onChange, onAddNewTeamMember }: Props) => {
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState<FacilitatorModel | null>(null);
    const { list: facilitators } = useFacilitators();

    useEffect(() => {
        if(!selected)
            return;
        onChange(selected.id)
    }, [selected]);

    useEffect(() => {
        if(!value)
            return;
        const _selected = facilitators.find(f => f.id === value);
        setSelected(_selected ?? null);
    }, [value, facilitators]);


    return (
        <div className="facilitator-input">
            <label
                onFocus={() => setShow(true)}
                onBlur={() => setShow(false)}
            >
                <input 
                    type="text"
                    readOnly
                    value={selected?.name ?? ''}
                    
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M5 7L9 11L13 7" stroke="#151515" stroke-width="1.5"/>
                </svg>
            </label>
            {show && (
                <div className="facilitator-input__options">
                    {facilitators.map((f, i) => (
                        <button 
                            key={i} 
                            type="button" 
                            onMouseDown={() => setSelected(f)}
                            onPointerDown={() => setSelected(f)}
                        >
                            <span className="name"> {f.name} </span>
                            <span className="role"> {f.roleLabel} </span>
                        </button>
                    ))}
                    <button className="add-facilitator" onClick={onAddNewTeamMember}>
                        + Add New Team Member
                    </button>
                </div>
            )}
        </div>
    )
}